(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { mapDependencies } from './dependenciesMap.generated.js';
import { medianDependencies } from './dependenciesMedian.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMad } from '../../factoriesAny.js';
export var madDependencies = {
  absDependencies: absDependencies,
  mapDependencies: mapDependencies,
  medianDependencies: medianDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createMad: createMad
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(madDependencies, "madDependencies", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesMad.generated.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();